import { render, staticRenderFns } from "./PageContentTemplateContent.vue?vue&type=template&id=1cac9880&scoped=true"
import script from "./PageContentTemplateContent.vue?vue&type=script&lang=js"
export * from "./PageContentTemplateContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cac9880",
  null
  
)

export default component.exports